import React, { useEffect, useState } from 'react';
import CustomerShell from '../../components/layout/CustomerShell';
import PushNotificationManager from '../../components/PushNotificationManager';

export default function CustomerNotifications(){
  const [items, setItems] = useState([]);
  const [status, setStatus] = useState('idle');
  const [error, setError] = useState(null);

  const API_URL = process.env.REACT_APP_BACKEND_URL || '/api';

  const fetchNotifications = async () => {
    try {
      setStatus('loading');
      const res = await fetch(`${API_URL}/customer/dashboard/notifications`, {
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' }
      });
      if (!res.ok) throw new Error('Failed to fetch notifications');
      const data = await res.json();
      setItems(data.notifications || []);
      setStatus('succeeded');
    } catch (e) { setError(e.message); setStatus('failed'); }
  };

  const markRead = async (id) => {
    try {
      const res = await fetch(`${API_URL}/customer/dashboard/notifications/${id}/read`, {
        method: 'PUT',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' }
      });
      if (res.ok) setItems(prev => prev.map(n => n._id === id ? { ...n, isRead: true } : n));
    } catch {}
  };

  useEffect(() => { fetchNotifications(); }, []);

  const unread = items.filter(n => !n.isRead).length;

  return (
    <CustomerShell>
      <div style={{ maxWidth: 900, margin: '0 auto', padding: 16 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
          <h2 style={{ margin: 0 }}>Notifications</h2>
          <div style={{ fontSize: 12, color: '#6B7280' }}>{unread} unread</div>
        </div>
        
        {/* Push Notification Manager */}
        <PushNotificationManager />
        {status === 'loading' && <div>Loading...</div>}
        {error && <div style={{ color: 'red' }}>{error}</div>}
        <div style={{ display: 'grid', gap: 12 }}>
          {items.map(n => (
            <div key={n._id} style={{ background: 'white', border: '1px solid #E5E7EB', borderLeft: n.isRead ? '4px solid transparent' : '4px solid #0D7463', borderRadius: 8, padding: 16 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ fontWeight: 600 }}>{n.title || n.type}</div>
                {!n.isRead && <button onClick={() => markRead(n._id)} style={{ border: '1px solid #D1D5DB', background: 'white', borderRadius: 6, padding: '6px 10px', cursor: 'pointer' }}>Mark read</button>}
              </div>
              <div style={{ color: '#374151' }}>{n.message}</div>
              <div style={{ fontSize: 12, color: '#6B7280' }}>{new Date(n.createdAt).toLocaleString()}</div>
            </div>
          ))}
          {items.length === 0 && status === 'succeeded' && <div style={{ color: '#6B7280' }}>No notifications</div>}
        </div>
      </div>
    </CustomerShell>
  );
}







